import React from "react";

export default function Footer() {
  return (
    <p className="font2">
      만든이: 밍기뉴예쁘다<br></br>
      수익없이 운영되고 있습니다.
    </p>
  );
}
